module.exports = __webpack_public_path__ + "static/media/Webscape.438f4588.jpeg";